export const config = {
    mediaUrl: process.env.GATSBY_MEDIA_URL || ""
};

(global as any).config = config;